import { useLocale, useTranslate } from 'app/[locale]/hooks/useTranslate';
import { SectionTitle } from '../SectionTitle';
import Image from 'next/image';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';

export const AccessSection = (): JSX.Element => {
  const { t } = useTranslate();
  const locale = useLocale();
  const { ref } = useAttentionTracker({ sectionName: 'main_access' });

  return (
    <section className="md:space-y-32 space-y-16 md:max-w-homepage px-4 md:px-10" ref={ref}>
      <SectionTitle title={t.home.MAIN_ACCESS_TITLE} description={t.home.MAIN_ACCESS_DESC} isDark />
      <Image
        className="w-full select-none"
        src={`/callabo/homepage/main/access_${locale}.png`}
        width={1187}
        height={290}
        alt="access_management"
      />
    </section>
  );
};
